<template>
    <div class="comment-radio">
        <div v-if="type === 'radio'">
            <el-radio-group v-model="commentStatus">
                <el-radio v-for="(commentItem, index) in status" :key="index" :label="index"
                    >{{ commentItem }}
                </el-radio>
            </el-radio-group>
        </div>
        <div v-else>
            <el-select v-model="commentStatus" placeholder="请选择">
                <el-option v-for="(commentItem, index) in status" :key="index" :label="commentItem" :value="index">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
import ContentConfig from '@/module/ContentConfig';

export default {
    props: {
        form: {
            type: Object,
            default () {
                return {
                    can_comment: '1', // 是否可以评论 1可以 2不能
                    hide_comment: '1', //  1否 2是
                    hit_special: '0' // （1：必审；0：非必审）
                };
            }
        },
        type: {
            type: String,
            default: 'radio'
        }
    },
    data () {
        return {
            status: ContentConfig.status
        };
    },
    computed: {
        commentStatus: {
            get () {
                let type = ContentConfig.type;
                if (this.form.can_comment === '1') {
                    if (this.form.hide_comment === '2') {
                        return type.HIDE;
                    } else if (this.form.hit_special === '1') {
                        return type.AUDIT;
                    } else {
                        return type.NORMAL;
                    }
                } else {
                    return type.CLOSE;
                }
            },
            set (newValue) {
                let type = ContentConfig.type;
                switch (newValue) {
                case type.NORMAL:
                    this.form.can_comment = '1';
                    this.form.hide_comment = '1';
                    this.form.hit_special = '0';
                    break;
                case type.AUDIT:
                    this.form.can_comment = '1';
                    this.form.hide_comment = '1';
                    this.form.hit_special = '1';
                    break;
                case type.HIDE:
                    this.form.can_comment = '1';
                    this.form.hide_comment = '2';
                    this.form.hit_special = '0';
                    break;
                case type.CLOSE:
                    this.form.can_comment = '2';
                    this.form.hide_comment = '1';
                    this.form.hit_special = '0';
                    break;
                }
            }
        }
    }
};
</script>

<style lang="less" scoped>
.comment-radio {
    margin-bottom: 10px;
}
</style>
